module.exports = __webpack_public_path__ + "img/pdf-short.67547b2.png";